import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import Container = Phaser.GameObjects.Container;
import SpriteUtils from "@/utils/sprite-utils";
import {Keys} from "@/constants/key";
import CU from "@/utils/c-u";
import TimeUtils from "@/utils/time-utils";
import Text = Phaser.GameObjects.Text;
import {Tr} from "@/i18n/i18n";

export class SaleIntroPanel extends Container {

    private timer: Text | undefined = undefined;
    private startAt!: number;
    private timeComeCallback!: () => unknown;

    constructor(scene: Phaser.Scene, startAt: number, timeComeCallback: () => unknown) {
        super(scene);
        this.timeComeCallback = timeComeCallback;
        this.startAt = startAt;

        this.height = 110;

        const back = SpriteUtils.addImage(this.scene, -300, 0, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_PANEL_BACK).setOrigin(0, 0);
        SpriteUtils.setDispSize(back, CU.CANVAS_WIDTH, 152 * CU.S);
        this.add(back);

        let mainText = TextUtils.addTextByFamily(scene, Tr('bf.welc'),
            0, 30, '#ffc536', 15, 'normal', 600, Fonts.BENGALY_NORMAL);

        let comment = TextUtils.addTextByFamily(scene, Tr('bf.st'),
            0, 60, '#cbcbcb', 11, 'normal', 600, Fonts.BENGALY_NORMAL);

        this.timer = TextUtils.addTextByFamily(scene, '',
            0, 90, '#FFC536FF', 13, 'normal', 600, Fonts.BENGALY_NORMAL);
        this.refreshTimer();

        const separator = SpriteUtils.addSprite(this.scene!, 0, this.height, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR).setOrigin(0.5, 0.5);

        this.add([back, mainText, separator, comment, this.timer]);

        let timerId = setInterval(() => {
            if (!this.active) {
                clearInterval(timerId);
            } else {
                this.refreshTimer();
            }
        }, 1000);
    }

    private refreshTimer(): void {
        if (this.active && this.timer && this.startAt) {
            const remainSec = Math.floor((this.startAt - TimeUtils.getServerTimeMs()) / 1000);
            if (remainSec > 0) {
                this.timer.setText(Tr('bf.ts') + ' ' + TimeUtils.getDurationText(remainSec));
            } else {
                this.timeComeCallback();
            }
        }
    }
}
